export class DadosUsuario {
    acessos: string[];
    id: number;
    nome: string;
    perfil: string;
}